import { NavLink } from "react-router-dom"

const SideMenu = props => {
    return <div className="side-menu">
        <p className="text md bold danger">`{'POKE-CSS'}`</p>
        {/* <p className="text xs">on this page</p> */}
        <ul className="primary-list">
            {props.links.map((link, index) => <li key={index}><NavLink to={link.url} exact>{link.content}</NavLink></li>)}
        </ul>
    </div>
}

export default SideMenu